<div>
  <form [formGroup]="secondaryIdentifierForm" (ngSubmit)="submitForm()">
    <finxone-input
      type="text"
      class="mt-2"
      formControlName="secondaryIdentifier"
      placeholder="Secondary Identifier"
      [label]="'Secondary Identifier'"
      [value]="secondaryIdentifierForm?.get('secondaryIdentifier')?.value"
      [formControlInvalid]="
        secondaryIdentifierForm.controls['secondaryIdentifier'].dirty &&
        secondaryIdentifierForm.controls['secondaryIdentifier'].touched
      "
      [validationConfig]="[
        {
          type: 'required',
          message: 'Field is required'
        }
      ]"
    >
    </finxone-input>
    <div class="w-100 mt-6">
      <finx-button
        type="submit"
        [labeltext]="buttonContent"
        [buttonStyle]="!isAllowedGlobalStyling ? submitButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'submit-button w-100'"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
  </form>
</div>
